module.exports = __webpack_public_path__ + "img/laschet-klausurbewertung.d2b545d9.jpg";